// extracted by mini-css-extract-plugin
export default {"expandButt":"expandButt__XHmAZ"};